import Heading from 'common/components/Heading';
import React from 'react';

interface Props {
    currentValue?: string;
    industries: {
        key: string;
        title: string;
    }[];
    onChange(key: string): void;
}

const IndustrySelect = ({ currentValue, industries, onChange }: Props) => {
    const primary = [
        'technology',
        'business',
        'medical',
        'food',
        'realestate',
        'construction',
        'retail',
        'accounting',
        'entertainment',
    ];

    return (
        <div className="get-started-interactive-content get-started-interactive-content--industry-select">
            <div className="get-started-interactive-content__inner">
                {industries
                    .filter(i => primary.includes(i.key))
                    .map(i => (
                        <div className="get-started-interactive-content__inner__item" key={i.key}>
                            <label
                                className="input-card input-card--industry"
                                htmlFor={`radio-industry-${i.key}`}
                                title={i.title}
                            >
                                <input
                                    type="radio"
                                    name="industry"
                                    value={i.key}
                                    id={`radio-industry-${i.key}`}
                                    checked={currentValue === i.key}
                                    onChange={({ target: { value } }) => onChange(value)}
                                />
                                <span className="input-card__card">
                                    <Heading
                                        size="h6"
                                        variations={['heading--no-margin', 'heading--size3']}
                                    >
                                        {i.title}
                                    </Heading>
                                </span>
                            </label>
                        </div>
                    ))}

                <div
                    className="get-started-interactive-content__inner__item"
                    key="industry-select-see-all"
                >
                    <label className="select">
                        <span>See all</span>
                        <select
                            value={currentValue}
                            onChange={({ target: { value } }) => onChange(value)}
                        >
                            {industries
                                .filter(i => !primary.includes(i.key))
                                .map(i => (
                                    <option value={i.key} key={i.key}>
                                        {i.title}
                                    </option>
                                ))}
                        </select>
                    </label>
                </div>
            </div>
        </div>
    );
};

export default IndustrySelect;
